export function getTransactionLoading(state) {
    return state.TransactionReducer.isLoading;
}

export function getCoinPrices(state) {
    return state.TransactionReducer.prices;
}
